import * as actions from '../actions/cart';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
var initialState = {
  isProcessing: false,
  error: null,
  items: []
};
export default reducerWithInitialState(initialState).case(actions.requestGetCart, function (state) {
  return Object.assign({}, state, {
    isProcessing: true,
    error: null
  });
}).case(actions.requestAddCart, function (state) {
  return Object.assign({}, state, {
    isProcessing: true,
    error: null
  });
}).case(actions.requestDeleteCart, function (state, payload) {
  return {
    isProcessing: true,
    error: null,
    items: state.items.filter(function (item) {
      return item.id !== payload;
    })
  };
}).case(actions.requestClearCart, function () {
  return {
    isProcessing: true,
    error: null,
    items: []
  };
}).case(actions.receiveChangeCart, function (state, payload) {
  return Object.assign({}, state, {
    isProcessing: false,
    items: payload
  });
}).case(actions.failureCart, function (state, payload) {
  return Object.assign({}, state, {
    isProcessing: false,
    error: payload
  });
});